<template>
  <b-container fluid class="main-container">
    <div>
      <img
        @click="$router.push({ name: 'dashboard' })"
        src="https://firebasestorage.googleapis.com/v0/b/anyverse-f5dd9.appspot.com/o/images%2Fjl-ai.png?alt=media&token=fd49c0d4-2e5c-4fe1-a1b6-833dde5ffc7b"
        width="40"
        height="40"
        class="m-2 d-inline-block cursor-pointer"
      />

      <h5 @click="$router.push({ name: 'dashboard' })" class="d-inline-block text-white cursor-pointer">JeanLuc <sup>ai</sup></h5>
    </div>

    <router-view></router-view>
  </b-container>
</template>

<script>
import { BContainer } from "bootstrap-vue";

export default {
  name: "Dashboard",
  components: { BContainer },
};
</script>

<style scoped>
.main-container {
  padding-right: 0px;
  width: 100%;
}

@media (max-width: 576px) {
  .pl-60 {
    padding-left: 0px;
  }
}

@media (min-width: 678px) {
  .main-container {
    padding-left: 0px;
    padding-right: 0px;
  }
  .pl-60 {
    padding-left: 60px;
  }
}
</style>
